export interface ReasonDefinition {
  label: string;
  selectable: boolean; // Indicates if this reason should be available for filtering in the UI
}

export const reasonMap: Record<number, ReasonDefinition> = {
  2: { label: "Entnahme", selectable: true },
  10: { label: "Rückgabe", selectable: true },
  11: { label: "Inventur", selectable: true },
  12: { label: "Leer setzen", selectable: true },
  13: { label: "Wareneingang", selectable: true },
  14: { label: "Öffnen", selectable: true },
  20: { label: "Entnahme Verleihbox", selectable: true },
  21: { label: "Rückgabe Verleihbox", selectable: true },
  22: { label: "Storno Buchung", selectable: true },
  30: { label: "Wareneingang Packstation", selectable: false },
  31: { label: "Entnahme Packstation", selectable: false },
  40: { label: "Produktprüfung", selectable: false },
  41: { label: "Rückgabe (Prüfung)", selectable: false },
  50: { label: "Order group check", selectable: false },
  999: { label: "Artikel defekt", selectable: false }, // Defekter Artikel (Prüfung durch Magazin) - Interner Sonderstatus, nicht in Boostrack-API enthalten
};
